module.exports = __webpack_public_path__ + "static/media/goal_planner.9f677234.svg";